import { MAX_YEAR, MIN_YEAR } from '../constants/van'

function determineIsYearValid(year: number): boolean {
  return year >= MIN_YEAR && year <= MAX_YEAR
}

export default determineIsYearValid
